import { SearchResults } from './types';
import { BREAKPOINTS } from '../../breakpoints';

export const SEARCH_MIN_CHARS = 2;

export const SEARCH_DEBOUNCE_ms = 500;

export const EMPTY_RESULTS: SearchResults = {
	assets: { items: [], total: 0 },
	collections: { items: [], total: 0 },
	guidelines: { items: [], total: 0 },
	metaproperties: [],
	tags: [],
};

export const VIEWPORT_WIDTH_BREAKPOINTS = {
	MEDIUM: 1280,
	LARGE: 2560,
};

// !important used to override the default css
export const getResponsiveSpotlightWidth = () => `
	width: 100% !important;
	max-width: 400px;

	@media (max-width: ${BREAKPOINTS.TABLET}px) {
		width: 100% !important;
		max-width: 400px;
	}

	@media (min-width: ${VIEWPORT_WIDTH_BREAKPOINTS.MEDIUM}px) {
		width: 600px !important;
		max-width: none;
	}

	@media (min-width: ${VIEWPORT_WIDTH_BREAKPOINTS.LARGE}px) {
		width: 752px !important;
	}
`;

/** Context for AI: dropdown section render order. */
export const ORDER_OF_SECTIONS_IN_SPOTLIGHT_DROPDOWN = [
	'assets',
	'collections',
	'guidelines',
	'metaproperties',
	'tags',
];
